import { useMemo } from "react";
import { isAnyOf } from "../../../supporting";
import { useAppTesterContext } from "shared/contexts/AppTesterContext";

const useAppTester = () => {
  const appTester = useAppTesterContext();
  return useMemo(() => isAnyOf(appTester), [appTester])
}

export default useAppTester;import { useMemo } from "react";
import { isAnyOf } from "../../../supporting";
import { useAppTesterContext } from "shared/contexts/AppTesterContext";

const useAppTester = () => {
  const appTester = useAppTesterContext();
  return useMemo(() => isAnyOf(appTester), [appTester])
}

export default useAppTester;